import { useTestStore } from "../../hooks/store";
import Styles from "./TestComponentStyles.module.css";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import DangerousRoundedIcon from "@mui/icons-material/DangerousRounded";
import {
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Portal,
  Tooltip,
} from "@mui/material";
import { testType } from "../../utils/testHelper";
import { initBiletTest } from "../../utils/API/biletMethod";
import { useEffect, useState } from "react";
import { getLog } from "../../utils/API/userMethod";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
export function TestGreeting() {
  const testStore = useTestStore();
  const conditions = testStore.testType.conditions;

  const [loading, setLoading] = useState();

  const handleInitTest = async () => {
    testStore.setLoading();
    await testStore.initTest(testStore.biletId);
    testStore.stopLoading();
  };

  useEffect(() => {
    setLoading(testStore.testLoading);
  }, [testStore.testLoading]);

  return (
    <article className={Styles.test_greeting}>
      <h6>О тесте</h6>
      <List sx={{ maxWidth: "500px", width: "90%" }}>
        <ListItem>
          <ListItemIcon>
            <AccessTimeRoundedIcon
              fontSize="large"
              style={{ color: "var(--bckg-accent)" }}
            />
          </ListItemIcon>
          <ListItemText>Время</ListItemText>

          <ListItemText>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}>
              <h6>
                {(conditions.solvingTime === null && <AllInclusiveIcon />) ||
                  conditions.solvingTime}
              </h6>
            </div>
          </ListItemText>
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemIcon>
            <HelpOutlineRoundedIcon
              fontSize="large"
              style={{ color: "var(--bckg-accent)" }}
            />
          </ListItemIcon>

          <ListItemText>Всего вопросов</ListItemText>
          <ListItemText>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}>
              <h6>{conditions.questionCount}</h6>
            </div>
          </ListItemText>
        </ListItem>
        <Divider />

        <ListItem>
          <ListItemIcon>
            <DangerousRoundedIcon
              fontSize="large"
              style={{ color: "var(--bckg-accent)" }}
            />
          </ListItemIcon>
          <ListItemText>Макс. ошибок</ListItemText>
          <ListItemText>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                color: "red",
              }}>
              <h6>
                {(conditions.allovedErrors === null && <AllInclusiveIcon />) ||
                  conditions.allovedErrors}
              </h6>
            </div>
          </ListItemText>
        </ListItem>
        <Divider />
      </List>
      <button
        variant="contained"
        style={{ width: "300px", fontWeight: "bold" }}
        onClick={handleInitTest}
        disabled={loading}>
        {loading ? (
          <CircularProgress
            style={{ height: "18px", width: "18px" }}
            color="white"
          />
        ) : (
          "Приступить"
        )}
      </button>
    </article>
  );
}
